// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608180319/js/" + chunkId + "." + {"44":"7cacb4e8","225":"391eccc3","481":"6fd7cb01","486":"113639a7","770":"e7a9d798"}[chunkId] + ".0.9200542439839099.chunk.js";
};